import { TrackingEvent } from '../types'
import type { CohesionWebContext } from '@strata-monorepo/shared-types/src/window'

export type PageName = 'find-my-plan' | 'grid'

export interface PageViewedArgs {
  revisionId: string
  pageName: PageName
  webContext?: CohesionWebContext
}

export interface PageViewedProperties {
  revisionId: string
  pageName: PageName
  webContext?: CohesionWebContext
}

export class PageViewed extends TrackingEvent {
  properties: PageViewedProperties

  constructor(args: PageViewedArgs) {
    const { revisionId = '', pageName = '' as PageName, webContext } = args ?? {}
    super('PageViewed', 'redventures.usertracking.v2.PageViewed')

    this.properties = {
      revisionId,
      pageName,
      ...(webContext !== undefined && { webContext }),
    }
  }
}
